<template>
  <section>
    <transition name="fade">
      <div class="quiz" v-for="(q,index) in questions" :key="index" v-if="index === qidx && !done">
        <Counter :qidx="qidx" :index="index" :questionsLength="questions.length" />
        <div class="event">
          <div class="title">{{q.title}}</div>
          <div class="answers">
            <button
              class="answer"
              :class="{'answer--active': currentAnswer === index}"
              v-for="(a,index) in q.answers"
              @click="next(index)"
              :disabled="currentAnswer"
            >
              <span
                class="answer__text"
                :class="{'answer__text--active': currentAnswer === index}"
              >{{a.text}}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="done" v-if="done">
        <Done />
      </div>
    </transition>
  </section>
</template>

<style lang="scss" scoped>
.quiz {
  max-width: 375px;
  margin: 0 auto;
}
.title {
  text-align: center;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
}
.event {
  margin-top: 52px;
  padding: 0 31px;
}
.answers {
  margin-top: 49px;
  width: 100%;
}
.answer {
  background: #efefef;
  border-radius: 6px;
  padding: 17px 19px;
  min-height: 23px;
  text-align: center;
  width: 100%;
  border: none;
  outline: none;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
  &__text {
    color: #000000;
    font-weight: 500;
    font-size: 18px;
    &--active {
      color: #fff;
    }
  }
  &--active {
    background: #2f9e31;
  }
}
</style>

<script>
import Counter from "../components/Counter";
import Done from "../components/Done";
import questions from "../assets/questions";
export default {
  data: () => ({ questions, qidx: 0, currentAnswer: null, done: false }),
  components: { Counter, Done },
  methods: {
    next(index) {
      this.currentAnswer = index;
      setTimeout(() => {
        this.done = true;
        setTimeout(() => {
          if (this.qidx + 1 === this.questions.length) {
            this.$emit("switchScreen", "phoneEnter");
          }
          this.done = false;
          this.qidx++;
          this.currentAnswer = null;
        }, 1400);
      }, 200);
    }
  }
};
</script>